// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap___Alrw","actionsCol":"EnrolledClinics_actionsCol__2Ee4c"};